import { INameValue } from '@shared/interfaces/INameValue';

export const findConstraintName = (constraints: INameValue[], value?: string | null) => {
  const found = constraints.find((c) => c.value === value);
  if (found) return found.name;
  return '';
};
